import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalBody,
} from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";
// Redux
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";

import servicesIcon3 from "../../../assets/images/services-icon/wallet.png";

const ProfileMenu = (props) => {
  const [menu, setMenu] = useState(false);
  const [walletModal, setWalletModal] = useState(false);

  const [username, setusername] = useState("Admin");
  const authUser = JSON.parse(localStorage.getItem("authUser"));

  // Dummy wallet balance
  const [walletBalance, setWalletAmount] = useState(0);

  useEffect(() => {
    setusername(authUser?.user_name);
  }, [props.success]);

  const handleWalletModal = async (id) => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(
        `${process.env.REACT_APP_WEB_APP_URL}/api/get-mywallet`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const result = await response.json();

      if (response.status === 200) {
        setWalletAmount(result?.data?.balanced_amount);
        setWalletModal(true);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <React.Fragment>
      {/* Profile Dropdown */}
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item waves-effect p-0 border-0 bg-transparent"
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user shadow"
            src={authUser?.profile_pic}
            alt="Avatar"
            style={{ width: "40px", height: "40px", objectFit: "cover" }}
          />
        </DropdownToggle>

        <DropdownMenu
          className="dropdown-menu-end p-2 shadow-lg rounded-3 border-0"
          style={{ minWidth: "200px" }}
        >
          <div className="px-3 py-2 border-bottom">
            <h6 className="mb-0 fw-bold">{username}</h6>
            <small className="text-muted">{authUser?.email}</small>
          </div>

          <DropdownItem tag={Link} to="/profile" className="py-2">
            <i className="mdi mdi-account-circle font-size-17 me-2 text-primary" />
            {props.t("Profile")}
          </DropdownItem>

          {/* Wallet Menu */}
          <DropdownItem
            tag="a"
            href="#"
            onClick={() => handleWalletModal(authUser?.id)}
            className="py-2"
          >
            <i className="mdi mdi-wallet font-size-17 me-2 text-success" />
            {props.t("My Wallet")}
          </DropdownItem>

          <DropdownItem tag={Link} to="/auth-lock-screen" className="py-2">
            <i className="mdi mdi-lock-open-outline font-size-17 me-2 text-warning" />
            {props.t("Lock screen")}
          </DropdownItem>

          <div className="dropdown-divider" />

          <Link to="/logout" className="dropdown-item text-danger py-2">
            <i className="bx bx-power-off font-size-17 me-2 text-danger" />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>

      {/* Wallet Modal */}
      <Modal
        isOpen={walletModal}
        toggle={() => setWalletModal(!walletModal)}
        centered
        className="wallet-modal"
      >
        <ModalBody className="text-center p-5">
          <div className="d-flex justify-content-center align-items-center mb-3">
            <img
              src={servicesIcon3}
              alt="wallet"
              style={{ width: "60px", height: "60px" }}
            />
          </div>
          <h4 className="fw-bold mb-2">Wallet Balance</h4>
          <h2 className="fw-bolder text-success">LYD {walletBalance}</h2>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
};

const mapStatetoProps = (state) => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);
